import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { I18nService } from '@gruposaltaedu/liv-i18n/core';

const WHITE_LIST = [
  'assets',
  'googleapis.com',
  'accounts.google.com',
  'oauth2.googleapis.com',
  'openidconnect.googleapis.com'
];

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  const i18n = inject(I18nService);

  const currentLang = i18n.currentLanguage();

  const whitedList = new RegExp(WHITE_LIST.join('|')).test(req.url);

  if (whitedList) {
    return next(req);
  }

  if (req.headers.get('Accept-Language') === currentLang) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': currentLang
      }
    })
  );
};
